export default [
  /**
   *   KUISIONER INSTITUSI
   */
  {
    path: "/lp3m/kuisioner-institusi",
    name: "lp3m-kuisioner-institusi",
    component: () => import("../../views/rektorat/lp3m/KuisionerInstitusi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LP3M", url: "/submenu/lp3m" },
        { title: "Kuisioner Institusi", active: true },
      ],
      pageTitle: "Kuisioner Institusi",
    },
  },
  {
    path: "/lp3m/kuisioner-institusi/add",
    name: "lp3m-kuisioner-institusi-add",
    component: () =>
      import("../../views/rektorat/lp3m/TambahKuisionerInstitusi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LP3M", url: "/submenu/lp3m" },
        { title: "Kuisioner Institusi", url: "/lp3m/kuisioner-institusi" },
        { title: "Tambah Kuisioner Institusi", active: true },
      ],
      pageTitle: "Tambah Kuisioner Institusi",
    },
  },
  {
    path: "/lp3m/kuisioner-institusi/edit/:quizId",
    name: "lp3m-kuisioner-institusi-edit",
    component: () =>
      import("../../views/rektorat/lp3m/EditKuisionerInstitusi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LP3M", url: "/submenu/lp3m" },
        { title: "Kuisioner Institusi", url: "/lp3m/kuisioner-institusi" },
        { title: "Sunting Kuisioner Institusi", active: true },
      ],
      pageTitle: "Sunting Kuisioner Institusi",
    },
  },
  /**
   *   KUISIONER MATKUL
   */
  {
    path: "/lp3m/kuisioner-matkul",
    name: "lp3m-kuisioner-matkul",
    component: () => import("../../views/rektorat/lp3m/KuisionerMatkul.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LP3M", url: "/submenu/lp3m" },
        { title: "Kuisioner Matakuliah", active: true },
      ],
      pageTitle: "Kuisioner Matakuliah",
    },
  },
  {
    path: "/lp3m/kuisioner-matkul/add",
    name: "lp3m-kuisioner-matkul-add",
    component: () =>
      import("../../views/rektorat/lp3m/TambahKuisionerMatkul.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LP3M", url: "/submenu/lp3m" },
        { title: "Kuisioner Matkul", url: "/lp3m/kuisioner-matkul" },
        { title: "Tambah Kuisioner Matkul", active: true },
      ],
      pageTitle: "Tambah Kuisioner Matkul",
    },
  },
  {
    path: "/lp3m/kuisioner-matkul/edit/:quizId",
    name: "lp3m-kuisioner-matkul-edit",
    component: () =>
      import("../../views/rektorat/lp3m/EditKuisionerMatkul.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LP3M", url: "/submenu/lp3m" },
        { title: "Kuisioner Matkul", url: "/lp3m/kuisioner-matkul" },
        { title: "Sunting Kuisioner Matkul", active: true },
      ],
      pageTitle: "Sunting Kuisioner Matkul",
    },
  },
  /**
   *   REPORT KUISIONER
   */
  {
    path: "/lp3m/report-kuisioner",
    name: "lp3m-report-kuisioner",
    component: () => import("../../views/rektorat/lp3m/ReportKuisioner.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "LP3M", url: "/submenu/lp3m" },
        { title: "Report Kuisioner", active: true },
      ],
      pageTitle: "Report Kuisioner",
    },
  },
];
